module.exports = __webpack_public_path__ + "assets/01.27656dae.pdf";